"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateParserOptions = exports.MatchNode = exports.FunctionNode = exports.TreeNode = exports.ChainNode = exports.VisiterOption = exports.VisiterStore = exports.Parser = exports.MAX_VISITER_CALL = exports.parserMap = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var parserMap = new Map();
exports.parserMap = parserMap;
var MAX_VISITER_CALL = 1000000;
exports.MAX_VISITER_CALL = MAX_VISITER_CALL;

var Parser = function Parser() {
  (0, _classCallCheck2["default"])(this, Parser);
  this.rootChainNode = null;
  this.firstSet = new Map();
  this.firstOrFunctionSet = new Map();
  this.relatedSet = new Map();
};

exports.Parser = Parser;

var VisiterStore = function VisiterStore(scanner, parser) {
  (0, _classCallCheck2["default"])(this, VisiterStore);
  this.scanner = scanner;
  this.parser = parser;
  this.restChances = [];
  this.stop = false;
};

exports.VisiterStore = VisiterStore;

var VisiterOption = function VisiterOption() {
  (0, _classCallCheck2["default"])(this, VisiterOption);
  this.onCallVisiter = void 0;
  this.onVisiterNextNode = void 0;
  this.onSuccess = void 0;
  this.onFail = void 0;
  this.onMatchNode = void 0;
  this.generateAst = true;
  this.enableFirstSet = true;
};

exports.VisiterOption = VisiterOption;

var ChainNode = function ChainNode(parentIndex) {
  (0, _classCallCheck2["default"])(this, ChainNode);
  this.parentIndex = parentIndex;
  this.parentNode = void 0;
  this.childs = [];
  this.astResults = [];
  this.creatorFunction = null;
  this.functionName = void 0;
  this.solveAst = null;
};

exports.ChainNode = ChainNode;

var TreeNode = function TreeNode(parentIndex) {
  (0, _classCallCheck2["default"])(this, TreeNode);
  this.parentIndex = parentIndex;
  this.parentNode = void 0;
  this.childs = [];
};

exports.TreeNode = TreeNode;

var FunctionNode = function FunctionNode(chainFunction, parentIndex, parser) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, FunctionNode);
  this.chainFunction = chainFunction;
  this.parentIndex = parentIndex;
  this.parser = parser;
  this.parentNode = void 0;

  this.run = function () {
    return _this.chainFunction()(_this.parentNode, _this.chainFunction, _this.parentIndex, _this.parser);
  };
};

exports.FunctionNode = FunctionNode;

var MatchNode = function MatchNode(matchFunction, matching, parentIndex) {
  var _this2 = this;

  (0, _classCallCheck2["default"])(this, MatchNode);
  this.matchFunction = matchFunction;
  this.matching = matching;
  this.parentIndex = parentIndex;
  this.parentNode = void 0;

  this.run = function (scanner) {
    var isCostToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return _this2.matchFunction(scanner, isCostToken);
  };
};

exports.MatchNode = MatchNode;

var CreateParserOptions = function CreateParserOptions() {
  (0, _classCallCheck2["default"])(this, CreateParserOptions);

  this.cursorTokenExcludes = function () {
    return false;
  };
};

exports.CreateParserOptions = CreateParserOptions;